export const ENTIRE_VISIBLE_THRESHOLD = 1;
export const NON_VISIBLE_THRESHOLD = 0;
export const VISIBLE_THRESHOLD = 0.001;

export const IN_AND_OUT_THRESHOLD_INTERVAL = [
  NON_VISIBLE_THRESHOLD,
  ENTIRE_VISIBLE_THRESHOLD,
];

function cb(callback, entries) {
  if (entries.length > 1) callback(entries);
  else callback(entries[0]);
}

class CustomIntersectionObserver {
  constructor(callback, { onInAndOut, threshold, thresholdMargin } = {}) {
    const customThreshold =
      threshold ||
      (onInAndOut && IN_AND_OUT_THRESHOLD_INTERVAL) ||
      ENTIRE_VISIBLE_THRESHOLD;

    this.observer = new IntersectionObserver(
      (entries) => cb(callback, entries),
      {
        rootMargin: thresholdMargin,
        threshold: customThreshold,
      },
    );
  }

  static elementIsEntirelyVisible(entry) {
    return entry.intersectionRatio === ENTIRE_VISIBLE_THRESHOLD;
  }

  static elementIsVisible(entry) {
    return entry.intersectionRatio * 100 > 0;
  }

  observe(element) {
    this.observer.observe(element);
    return this;
  }

  disconnect() {
    this.observer.disconnect();
    return this;
  }
}

export default CustomIntersectionObserver;
